import { AspectRatio, Box } from "@radix-ui/themes";
import NextImage from "next/image";

const Image: React.FC<{
  src: string;
  alt: string;
  isFirst?: boolean;
  isHeader?: boolean;
  isLast?: boolean;
  isPriority?: boolean;
}> = ({ alt, isFirst, isHeader, isLast, isPriority, src }) => {
  return (
    <Box mt={isFirst ? "0" : "4"} mb={isLast ? "0" : "4"}>
      <AspectRatio ratio={16 / 8}>
        <NextImage
          alt={alt}
          fill
          priority={isPriority}
          sizes={`${
            isHeader ? "(max-width: 1096px) 100vw" : "(max-width: 672px) 100vw"
          }`}
          src={src}
          style={{
            objectFit: "cover",
            borderRadius: "8px",
            boxShadow: "rgba(0, 0, 0, 0.16) 0px 2px 8px",
          }}
        />
      </AspectRatio>
    </Box>
  );
};

export default Image;
